<div class="p-2.5">
  <h4 class="w-100 text-center">¡ATENCIÓN!</h4>
  <p>¡ATENCIÓN! Si la segunda página de tu PDF ya está en blanco, no es necesario clicar esta opción.</p>
</div>
